import dynamic from 'next/dynamic';
import formatDate from 'utils/format-date';
import Image from 'core/image';
import LandingSection from 'components/landing/components/landing-section';
import StarContainer from 'components/blog/banner/star-container';
import styles from 'styles/Banner.module.scss';
import Title from 'core/title';
import titleCase from 'utils/to-title';
import { usePageInfo } from 'context/PageInfoContext';
import { useTranslations } from 'next-intl';

const DefaultImage = dynamic(() =>
    import('components/blog/banner/default-image')
);

const Banner = () => {
    const { pageInfo } = usePageInfo();
    const t = useTranslations('banner');
    const authorName =
        pageInfo.page_context.author_avatar !== null ?
            pageInfo.page_context.author_name :
            t('author-name');
    const updatedDate = titleCase(formatDate(pageInfo.page_context.datetime_update));

    return (
        <LandingSection disableGradient disableTopPadding disableBottomPadding>
            <meta itemProp="dateModified" content={updatedDate} />
            <div className={styles.title_container}>
                <Title content={pageInfo.page_context.title} align
                    extraProps={{ itemProp: 'name', itemID: pageInfo.page_context.page_full_url }} />
                <Title
                    content={pageInfo.page_context.meta_description}
                    titleType="subtitle"
                    align
                    extraProps={{ itemProp: 'description' }}
                />
            </div>
            <div className={styles.author_container}>
                <div
                    className={styles.avatar}
                    itemType="https://schema.org/Person"
                    itemProp="author"
                    itemScope
                >
                    {pageInfo.page_context.author_avatar !== null ?
                        (
                            <Image
                                src={pageInfo.page_context.author_avatar}
                                alt={pageInfo.page_context.author_name}
                                width={50}
                                height={50}
                            />
                        ) :
                        (
                            <DefaultImage />
                        )}
                    <div className={styles.text_container}>
                        <span itemProp="name">{`${t('author')} ${authorName}`}</span>
                        <span><span className={styles.date_description}>{t('updated')}</span>{updatedDate}</span>
                    </div>
                </div>
                <StarContainer />
            </div>
        </LandingSection>
    );
};

export default Banner;
